import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AppSharedModule} from '../appShared.module';
import {AdminSidenavComponent} from '../shared/layout/side-navbar/admin-sidenav.component';

// Components
import {AdminDashboardComponent} from './dashboard/dashboard.component';
import {UsersComponent} from './pages/users/users.component';
import {UserComponent} from './pages/users/user/user.component';
import {SettingsComponent} from './pages/settings/settings.component';
import {ServicesComponent} from './pages/processes/admin-process.component';
import {AttestationComponent} from './pages/processes/attestation/attestation.component';
import {PropertiesComponent} from './pages/processes/accommodation/properties/properties.component';
import {WebinarComponent} from './pages/settings/webinar/webinar.component';
import {FileUploadComponent} from './components/file-upload/file-upload.component';
import {PartnersComponent} from './pages/settings/partners/partners.component';
import {PartnerComponent} from './pages/settings/partners/partner/partner.component';
import {BookingsComponent} from './pages/processes/bookings/bookings.component';
import {PreviewBookingComponent} from './pages/processes/bookings/preview-booking/preview-booking.component';
import {ManageUserFileComponent} from './components/manage-user-file/manage-user-file.component';
import {Select2Module} from 'ng-select2-component';

// Modules
import {CountUpModule} from 'ngx-countup';
import {NgxChartsModule} from '@swimlane/ngx-charts';

// Pipes
import {FilterPipe} from '../pipes/filterPipe.pipe';
import {PropertyFilterPipe} from '../pipes/PropertyFilter.pipe';
import {SellFilterPipe} from '../pipes/sellFilter.pipe';
import {LeadsComponent} from './pages/leads/leads.component';
import {ItemBadgesComponent} from '../shared/components/item-badges/item-badges.component';
import {ConfigurationI18nComponent} from './pages/settings/i18n/configurationI18n.component';
import {AdminGuard} from '../helpers/admin.guard';
import { RoundPipe } from '../helpers/round.pipe';
import {DevKitComponent} from "./pages/dev-kit/dev-kit.component";


export const AppBackCareRouteListe: Routes = [

  {
    path: '',
    component: AdminSidenavComponent,
    canActivateChild: [AdminGuard],
    children: [
      {path: 'login', redirectTo: '/login', pathMatch: 'full'},
      {path: 'properties/list', component: PropertiesComponent},
      {path: 'bookings/list', component: BookingsComponent},
      {path: 'home', component: AdminDashboardComponent},
      {path: 'users', component: UsersComponent},
      {path: 'users/:id', component: UserComponent},
      {path: 'settings', component: SettingsComponent},
      {path: 'settings/housing-partner', component: PartnersComponent},
      {path: 'settings/i18n', component: ConfigurationI18nComponent},
      {path: 'settings/housing-partner/:id', component: PartnerComponent},
      {path: 'services', component: ServicesComponent},
      {path: 'attestation', component: AttestationComponent},
      {path: 'leads', component: LeadsComponent},
      {path: 'dev-kit', component: DevKitComponent},
      // { path: 'webinar', component: WebinarComponent },
      {path: '',redirectTo:'/admin/home',pathMatch: 'full'},
  ]},
  {path: '**',redirectTo:'/admin/home',pathMatch: 'full'},

];


@NgModule({
    imports: [
        RouterModule.forChild(AppBackCareRouteListe),
        AppSharedModule,
        CountUpModule,
        Select2Module,
        // KPI
        //NgApexchartsModule,
        NgxChartsModule,
        ItemBadgesComponent,
        AdminDashboardComponent,
        UsersComponent,
        SettingsComponent,
        ServicesComponent,
        AttestationComponent,
        PropertiesComponent,
        // Pipes
        FilterPipe,
        PropertyFilterPipe,
        SellFilterPipe,
        WebinarComponent,
        FileUploadComponent,
        PartnerComponent,
        ConfigurationI18nComponent,
        PartnersComponent,
        BookingsComponent,
        PreviewBookingComponent,
        ManageUserFileComponent,
        LeadsComponent,
        RoundPipe
    ],
    exports: [
        AdminDashboardComponent,
        UsersComponent,
        SettingsComponent,
        ServicesComponent,
        AttestationComponent,
        PropertiesComponent,
    ]
})
export class AppBackcareModule {}
